import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { TicketSummaryDto } from './type/TicketSummaryDto';

const ENDPOINT = `${APIConfiguration.marketplace}tickets`;

type ListTicketsQueryArgValue =
  | string
  | boolean
  | number
  | undefined
  | string[]
  | null;

export type ListTicketsQueryArgs = Record<string, ListTicketsQueryArgValue>;

export const listTicketsRequest = (
  payload: ListTicketsQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, payload, { encode: false, arrayFormat: 'brackets' }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const listTicketsQuery = async (
  payload: ListTicketsQueryArgs,
): Promise<BackResponse<TicketSummaryDto[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<TicketSummaryDto[]>>(
      listTicketsRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
